export default __webpack_public_path__ + "static/media/cs_icon_05.70d70db9.png";